/**
 * Faz 4 uzmanlık taksonomisi — okuma: yeni + eski alan; yazma: yalnızca yeni adlar.
 * Faz 5’te eski alanlar kalkabilir; bu helper’lar yazmayı yeni isimlere kilitler.
 */

export const getProfession = (obj) =>
  obj?.profession ?? obj?.Profession ?? obj?.specialtyCategory ?? obj?.SpecialtyCategory ?? null;

export const getProfessionId = (obj) =>
  obj?.professionId ??
  obj?.ProfessionId ??
  obj?.specialtyCategoryId ??
  obj?.SpecialtyCategoryId ??
  getProfession(obj)?.id ??
  getProfession(obj)?.Id ??
  null;

export const getProfessionName = (obj) => {
  const profession = getProfession(obj);
  return (
    profession?.name ??
    profession?.Name ??
    profession?.specialtyCategoryName ??
    profession?.SpecialtyCategoryName ??
    profession?.categoryName ??
    obj?.professionName ??
    obj?.ProfessionName ??
    obj?.specialtyCategoryName ??
    obj?.SpecialtyCategoryName ??
    ""
  );
};

/** Doktor kaydındaki birincil uzmanlık (eski: branch) */
export const getPrimarySpecialty = (obj) =>
  obj?.primarySpecialty ??
  obj?.PrimarySpecialty ??
  obj?.branch ??
  obj?.Branch ??
  obj?.specialty ??
  obj?.Specialty ??
  null;

const isPresentId = (id) =>
  id != null &&
  String(id).trim() !== "" &&
  String(id).toLowerCase() !== "00000000-0000-0000-0000-000000000000";

export const getPrimarySpecialtyId = (obj) => {
  const candidates = [
    obj?.primarySpecialtyId,
    obj?.PrimarySpecialtyId,
    obj?.specialtyId,
    obj?.SpecialtyId,
    obj?.branchId,
    obj?.BranchId,
    getPrimarySpecialty(obj)?.id,
    getPrimarySpecialty(obj)?.Id,
  ];
  return candidates.find(isPresentId) ?? null;
};

export const getSpecialtyName = (obj) => {
  const specialty = getPrimarySpecialty(obj);
  return (
    specialty?.name ??
    specialty?.Name ??
    specialty?.specialtyName ??
    specialty?.SpecialtyName ??
    specialty?.branchName ??
    specialty?.BranchName ??
    obj?.specialtyName ??
    obj?.SpecialtyName ??
    obj?.branchName ??
    obj?.BranchName ??
    ""
  );
};

const toOptionalBoolean = (value) => {
  if (value === true || value === false) return value;
  if (value === 1 || value === "1" || value === "true" || value === "True") return true;
  if (value === 0 || value === "0" || value === "false" || value === "False") return false;
  return undefined;
};

export const getProfessionIsEnabiz = (obj) => {
  const profession = getProfession(obj);
  return toOptionalBoolean(
    profession?.isEnabiz ?? profession?.IsEnabiz ?? obj?.isEnabiz ?? obj?.IsEnabiz
  );
};

/** Meslek Doktor ise hizmet paketi yalnızca 1 seans olabilir. */
export const getProfessionIsDoctorService = (obj) => {
  const profession = getProfession(obj);
  return (
    toOptionalBoolean(
      profession?.isDoctorService ??
        profession?.IsDoctorService ??
        obj?.isDoctorService ??
        obj?.IsDoctorService
    ) === true
  );
};

/** İlk açık boolean kazanır. Hiçbiri yoksa tanı/e-Nabız istenmez. */
export const resolveIsEnabiz = (...sources) => {
  for (const source of sources) {
    const value = getProfessionIsEnabiz(source);
    if (value === true || value === false) return value;
  }
  return false;
};

export const getProfessionSessionDuration = (obj) => {
  const profession = getProfession(obj);
  return (
    profession?.defaultSessionDuration ??
    profession?.DefaultSessionDuration ??
    obj?.defaultSessionDuration ??
    obj?.DefaultSessionDuration
  );
};

/** Liste/entity öğesinde görünen ad (meslek veya uzmanlık kaydı) */
export const getTaxonomyEntityName = (item) =>
  item?.name ??
  item?.Name ??
  item?.specialtyCategoryName ??
  item?.SpecialtyCategoryName ??
  item?.branchName ??
  item?.BranchName ??
  item?.specialtyName ??
  item?.SpecialtyName ??
  item?.title ??
  "";

/** Doktor create/update / profile/specialty yazma gövdesi */
export const buildDoctorTaxonomyWriteFields = (values = {}) => ({
  professionId:
    values.professionId ??
    values.specialtyCategoryId ??
    values.specialtyCategory?.id ??
    values.profession?.id ??
    null,
  primarySpecialtyId:
    values.primarySpecialtyId ??
    values.specialtyId ??
    values.branchId ??
    values.branch?.id ??
    values.primarySpecialty?.id ??
    null,
  titleId: values.titleId || values.title?.id || null,
});
